import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { Project, SearchOptions } from '@partiri-cloud/types';
import { WaitingListGuard } from '../waiting-list.guard';

/**
 * @file projects.ts
 * Class for the projects client
 */
export class ProjectsApi {

  endpoint = '/projects'

  constructor(private http: HttpClient) {
  }

  /**
   * List all projects
   * @returns Project[]
   */
  public list(workspaceId: string): Observable<Project[]> {
    return this.http.get<Project[]>(this.endpoint, { params: { workspace: workspaceId } });
  }

  /**
   * Requests a single Project
   * @param id 
   * @returns Project
   */
  public read(id: string): Observable<Project> {
    return this.http.get<Project>(`${this.endpoint}/${id}`)
  }

  /**
   * Create a new project to combine services
   * @param project
   */
  @WaitingListGuard()
  public create(project: Project): Observable<Project> {
    return this.http.post<Project>(this.endpoint, project)
  }

  /**
   * Update the project data by id
   * @param id 
   * @param project
   * @returns Project
   */
  @WaitingListGuard()
  public update(id: string, project: Project): Observable<Project> {
    return this.http.put<Project>(`${this.endpoint}/${id}`, project)
  }

  /**
   * Delete the project
   * @param id 
   */
  @WaitingListGuard()
  public delete(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.endpoint}/${id}`)
  }

  /**
   * Search projects by name within a workspace
   * @param workspaceId
   * @param searchOptions
   */
  public search(workspaceId: string, searchOptions: SearchOptions): Observable<Project[]> {
    return this.http.post<Project[]>(`${this.endpoint}/search`, { ...searchOptions, fk_workspace: workspaceId })
  }
}
